import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface TransactionUser {
    user_id: string;
    type: TransactionUserType;
    update_timestamp: string;
    id: string;
    account_id: string;
    transaction_id: string;
    creation_timestamp: string;
}

export interface CreateTransactionUser {
    user_id?: string;
    type?: TransactionUserType;
}

export enum TransactionUserType {
    RECEIVER = 'receiver',
    SENDER = 'sender',
    REMOVER = 'remover'
}

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    TRANSACTION_ID = 'transaction_id',
    USER_ID = 'user_id',
    TYPE = 'type'
}
export type TransactionUserQueryParams = QueryParams & DefaultQueryParams;
export type TransactionUserListResponse = PaginatedResponse<TransactionUser>;
